import { Injectable } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ComponentPortal } from '@angular/cdk/portal';

import { LoaderComponent } from '../components/loader/loader.component';

@Injectable({
  providedIn: 'root'
})
export class McRAILoader2 {
  private _isAttached = false;
  private _overlayRef: OverlayRef;
  private _hide: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private _overlay: Overlay
  ) {
    this._hide
      .pipe(
        debounceTime(300)
      )
      .subscribe(() => this._detach());
  }

  private _getConfig(): OverlayConfig {
    const config = new OverlayConfig();

    config.positionStrategy = this._overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();

    config.hasBackdrop = true;
    config.panelClass = 'cdk-overlay-pane--fullscreen';

    return config;
  }

  private _getPortal(): ComponentPortal<LoaderComponent> {
    return new ComponentPortal(LoaderComponent);
  }

  private _attach() {
    if (!this._isAttached) {
      this._isAttached = true;

      const config = this._getConfig();
      const portal = this._getPortal();

      this._overlayRef = this._overlay.create(config);
      this._overlayRef.attach(portal);
    }
  }
  private _detach() {
    if (this._overlayRef) {
      this._overlayRef.dispose();
      this._isAttached = false;
    }
  }

  public show(): void {
    this._attach();
  }

  public hide(): void {
    this._hide.next(false);
  }

}
